import { CircularProgress, Modal } from '@mui/material';
import React, { useEffect } from 'react'
import cssClasses from './LoaderModal.module.css'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Button from '../../Subcomponents/Button';
import MyTimer from '../../Subcomponents/Timer';

export default function LoaderModal({ allTransactions, open, timestamp, handleClose, mode, allotmentDetails, amount, message, ptrnNo }) {

    useEffect(() => {
        if (mode === 'status') {
            console.log(allTransactions)
        }
    }, [mode])

    return (
        <Modal
            open={open}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={[
                {
                    ".MuiBackdrop-root": {
                        background: "rgba(52, 64, 84, 0.7)",
                    },
                },
            ]}
            disableAutoFocus={true}
        >
            <div className={cssClasses.mainContainer}>
                <div className={cssClasses.content}>
                    {mode === 'pending' &&
                        <div className={cssClasses.wrapper}>
                            <div className={cssClasses.icon}>
                                < CircularProgress style={{ color: "#FEC84B", width: "100%", height: "100%" }} />
                            </div>
                            <p className={cssClasses.customMsg}>{message}</p>
                            {message === 'Waiting for payment on POS machine' &&
                                <p className={cssClasses.customMsg}>Transaction Number : {ptrnNo}</p>
                            }
                            {message === 'Waiting for payment on POS machine' &&
                                <p style={{
                                    display: 'flex',
                                    gap: '2rem'
                                }} className={cssClasses.cautionMsg}>
                                    Transaction expires in <MyTimer css={{ fontSize: "2.4rem", color: "#98A2B3" }} expiryTimestamp={timestamp} />
                                </p>
                            }
                            <p className={cssClasses.cautionMsg}>Please do not press back button or close app.</p>
                        </div>
                    }
                    {mode === 'complete' &&
                        < div className={cssClasses.wrapper}>
                            <div className={cssClasses.icon}>
                                <CheckCircleOutlineIcon style={{ color: "#32D583", width: "100%", height: "100%" }} />
                            </div>
                            <div>
                                <p className={cssClasses.customMsg}>Payment Successful</p>
                                <p className={cssClasses.subText}>Completed on {new Date().toDateString()}</p>
                            </div>
                            <div className={cssClasses.detailsBox}>
                                <p className={cssClasses.paymentInfo}>Amount : {amount}</p>
                                <p className={cssClasses.paymentInfo}>Lead name : {allotmentDetails.leadId.personId.name}</p>
                                <p className={cssClasses.paymentInfo}>Project name : {allotmentDetails.inventoryMergedId?.inventoryMergeId ? allotmentDetails.inventoryMergedId?.unit1Id?.projectId?.projectName : allotmentDetails.unitId.projectId.projectName}</p>
                                {allotmentDetails.inventoryMergedId?.inventoryMergeId ?
                                    <p className={cssClasses.paymentInfo}>Unit Type : {allotmentDetails.inventoryMergedId?.unit1Id?.inventoryTypeId.type} - {allotmentDetails.inventoryMergedId?.unit2Id?.inventoryTypeId.type}</p>
                                    :
                                    <p className={cssClasses.paymentInfo}>Unit Type : {allotmentDetails.unitId.inventoryTypeId.type}</p>}
                                {allotmentDetails.inventoryMergedId?.inventoryMergeId ?
                                    <p className={cssClasses.paymentInfo}>Unit No : {allotmentDetails.inventoryMergedId?.unit1Id?.unitNo} - {allotmentDetails.inventoryMergedId?.unit2Id?.unitNo}</p>
                                    :
                                    <p className={cssClasses.paymentInfo}>Unit No : {allotmentDetails.unitId.unitNo}</p>
                                }
                            </div>
                            <div>
                                <Button clicked={handleClose} btnName={'Done'} style={{
                                    fontSize: "1.6rem",
                                    lineHeight: "2.4rem",
                                    color: "#FFF",
                                    backgroundColor: "#007FFF",
                                    borderRadius: "0.8rem",
                                }}
                                    padding={"0.65rem 2.5rem"} />
                            </div>
                        </div>
                    }
                    {mode === 'expired' &&
                        < div className={cssClasses.wrapper}>
                            <div className={cssClasses.icon}>
                                <HighlightOffIcon style={{ color: "red", width: "100%", height: "100%" }} />
                            </div>
                            <div>
                                <p className={cssClasses.customMsg}>Payment Failed</p>
                                <p className={cssClasses.subText}>{message}</p>
                            </div>
                            <p className={cssClasses.cautionMsg}>Create a new transaction and try again.</p>
                            <div>
                                <Button clicked={handleClose} btnName={'Done'} style={{
                                    fontSize: "1.6rem",
                                    lineHeight: "2.4rem",
                                    color: "#FFF",
                                    backgroundColor: "#007FFF",
                                    borderRadius: "0.8rem",
                                }}
                                    padding={"0.65rem 2.5rem"} />
                            </div>
                        </div>
                    }
                    {mode === 'status' &&
                        < div className={cssClasses.wrapper}>
                            <div className={cssClasses.icon}>
                                {allTransactions[0].status === 'expired' ?
                                    <HighlightOffIcon style={{ color: "red", width: "100%", height: "100%" }} />
                                    :
                                    <CheckCircleOutlineIcon style={{ color: "#32D583", width: "100%", height: "100%" }} />
                                }
                            </div>
                            <div>
                                <p className={cssClasses.customMsg}>{message}</p>
                                <p className={cssClasses.subText}>Status Check Completed</p>
                                <p className={cssClasses.subText}>Completed on {new Date().toDateString()}</p>
                            </div>
                            {allTransactions.map((m) => (
                                <div className={cssClasses.detailsBox}>
                                    <p className={cssClasses.paymentInfo}>Transaction Number : {m.paymentDetails.ptrnNo}</p>
                                    <p className={cssClasses.paymentInfo}>Amount : {m.amount}</p>
                                    <p className={cssClasses.paymentInfo}>Status : {m.status}</p>
                                </div>
                            ))
                            }
                            <div>
                                <Button clicked={handleClose} btnName={'Done'} style={{
                                    fontSize: "1.6rem",
                                    lineHeight: "2.4rem",
                                    color: "#FFF",
                                    backgroundColor: "#007FFF",
                                    borderRadius: "0.8rem",
                                }}
                                    padding={"0.65rem 2.5rem"} />
                            </div>
                        </div>
                    }
                </div>
            </div >
        </Modal >
    )
}
